import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  standalone: false,
  selector: "dua-input-field",
  templateUrl: "./input-field.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./input-field.component.scss"],
})
export class InputFieldComponent implements OnInit {
  private static idCounter = 0;
  readonly inputId: string;

  @Input() label!: string;
  @Input() adjusted: boolean = false;
  @Input() isValidCallback!: (value: string) => boolean;
  @Input() saveOnEnter: boolean = true;
  @Input() disabled!: boolean;
  @Output() save: EventEmitter<string> = new EventEmitter();
  @Output() valueChange: EventEmitter<string> = new EventEmitter();

  @Input() text!: string;

  hasErrors!: boolean;

  constructor() {
    this.inputId = `dua-input-field-${++InputFieldComponent.idCounter}`;
  }

  ngOnInit(): void {}

  saveInput(event: KeyboardEvent) {
    const value = (event.target as HTMLInputElement).value;

    if (this.isValidCallback && !this.isValidCallback(value)) {
      this.hasErrors = true;
      return;
    }

    if (this.saveOnEnter) {
      this.save.emit(value);
      (event.target as HTMLInputElement).value = "";
      this.text = "";
    }
  }

  onChange(event: string) {
    this.hasErrors = false;
    this.valueChange.emit(event);
  }
}
